var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82495 7.62184C7.36937 8.01087 6.63063 8.01087 6.17505 7.62184L0.341705 2.64064C-0.113902 2.25157 -0.113902 1.62079 0.341705 1.23173C0.797323 0.842678 1.53601 0.842678 1.99163 1.23173L7 5.50851L12.0084 1.23173C12.464 0.842678 13.2027 0.842678 13.6583 1.23173C14.1139 1.62079 14.1139 2.25157 13.6583 2.64064L7.82495 7.62184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.f031c06b4ea3325f443404afd3c0cae4.svg";
export { ForwardRef as ReactComponent };